var tw = tw || {};
tw.CulinaryShowsListings = (function () {
	//test.
    // console.log('test reportsjs');
	var _log = false,
		basePath = decodeURIComponent($("[data-basepath]").data("basepath")),
		$reports = $('.js-reports'),

		//TEMPLATES
		reportDetailsSSTemplate = $('#reportDetailsSSTemplate').html(),
		preloaderTemplate = $('#preloaderTemplate').html();

	/**
	 * Get All Reports By Region
	 */
	var getAllReportsByRegion = function () {
		if (_log) console.log('GetAllListingsForCulinaryMap()');

		var compiledTemplate = Template7.compile(preloaderTemplate),
			htmlPreloader = compiledTemplate(),
			reportType = CulinaryBingMap.Map.getReportType();
		$('#reportsAll').html(htmlPreloader);

		if (_log) console.log('reportType:', reportType);

		$.ajax({
			url: '/culinaryepisodes/GetAllListingsForCulinaryMap',
			data: {
				"reportType": reportType
			},
			type: "GET",
			success: function (data) {
				if (_log) console.log('getAllReportsByRegion.data.length:', data);
				updateEpisodeFeaturesPill(data.length);
				CulinaryBingMap.Map.addPushpinCluster(data);
				CulinaryBingMap.Map.getEpisodeData(data);
			},
			error: function (xhr, status, error) {
				console.error(xhr, status, error);
			}
		});

		$.ajax({
			url: '/culinaryepisodes/GetListingsNotRelatedToEpisodesForCulinaryMap',
			data: {
				"reportType": reportType
			},
			type: "GET",
			success: function (data) {
				if (_log) console.log('getListingsNotRelatedToEpisodesForCulinaryMap.data.length:', data);

				updateNoEpisodeFeaturesPill(data);
				CulinaryBingMap.Map.getNoEpisodeData(data);
			},
			error: function (xhr, status, error) {
				console.error(xhr, status, error);
			}
		});
	};

	/**
	 * Update Episode Features pill item with the number of listings
	 * @param {number} numberOfListings - The number of listings to display
	 */
	var updateEpisodeFeaturesPill = function(numberOfListings) {
		var episodeFeaturesSpan = $('.js-episode-features');
		
		if (episodeFeaturesSpan.length > 0) {
			episodeFeaturesSpan.text(`(${numberOfListings})`);
		}
	}

	/**
	 * Update Episode Features pill item with the number of listings
	 * @param {*} data
	 */
	var updateNoEpisodeFeaturesPill = function(data) {
		var judgeFavoriteSpan = $('.js-judge-favorite');
		var culinaryGemSpan = $('.js-culinary-gem');
		var tempJudgeFavData = [];
		var tempCulinaryGemData = [];

		for (var i = 0; i < data.length; i++) {
			if (data[i].IsCulinaryGem) {
				tempCulinaryGemData.push(data[i]);
			} else if (data[i].IsJudgeFavorite) {
				tempJudgeFavData.push(data[i]);
			}
		}

		judgeFavoriteSpan.text(`(${tempJudgeFavData.length})`);
		culinaryGemSpan.text(`(${tempCulinaryGemData.length})`);
	}

	var showReports = function () {
		//if (_log) console.log('showReports()');
        $reports.removeClass('is-hidden');
	};

	var hideReports = function () {
		$reports.addClass('is-hidden');
	};

	var clearDetailsShowAll = function () {
		if(_log) console.log('clearDetailsShowAll()');
		emptyReportDetails();
		showReports();
	}

	/**
	 * Empty ReportDetails container div
	 */
	var emptyReportDetails = function () {
		if (_log) console.log('emptyReportDetails()');
		$('#reportDetails').html('');
	}

	var showReportSubpane = function (Id) {
		//console.log('showReportSubpane().Id: ', Id);
		//close any open subpanes
		tw.CulinaryShow.closeSubpanes();
		tw.CulinaryShow.openSubpane({
			subpane: Id
		});
	};

	/**
	 * Get Report Details
	 * @param {*} reportId 
	 */
	var getReportDetails = function (reportId, itemIndex, episodeNumber) {
		if (_log) console.group('getReportDetails()');
		if (_log) console.log('reportId:', reportId);

		emptyReportDetails();
		var compiledTemplate = Template7.compile(preloaderTemplate),
			htmlPreloader = compiledTemplate()
		$('#reportDetails').html(htmlPreloader);

		if (episodeNumber !== undefined) {
			$.ajax({
				url: '/culinaryepisodes/GetAllListingsForCulinaryMap',
				type: "POST",
				data: {
					ID: reportId,
				},
				success: function (data) {
					var selectedReport = data.find(function (report) {
						return report.ID === reportId;
					});

					if (_log) console.log('selectedReport.data: ', selectedReport);
					// Call addReportDetails with the filtered data
					addReportDetails(selectedReport);

				},
				error: function (xhr, status, error) {
					console.log(xhr, status, error);
				}
			});
		} else {
			$.ajax({
				url: '/culinaryepisodes/GetListingsNotRelatedToEpisodesForCulinaryMap',
				type: "POST",
				data: {
					ID: reportId,
				},
				success: function (data) {
					var selectedReportNotRelatedToEpisodes = data.find(function (report) {
						return report.ID === reportId;
					});

					if (_log) console.log('selectedReportNotRelatedToEpisodes.data: ', selectedReportNotRelatedToEpisodes);
					// Call addReportDetails with the filtered data
					addReportDetails(selectedReportNotRelatedToEpisodes, itemIndex);

				},
				error: function (xhr, status, error) {
					console.log(xhr, status, error);
				}
			});
		}

		if (_log) console.groupEnd();
	};

	/**
	 * Add Report Details to Stage
	 * @param {*} data 
	 * @param {*} itemIndex 
	 */
	var addReportDetails = function (data, itemIndex) {
		if (_log) console.log('addReportDetails()', data);

		var useTemplate = reportDetailsSSTemplate,
			compiledTemplate = Template7.compile(useTemplate);
			
		var jsonContent = {
			ID: data.ID,
			ItemIndex: itemIndex,
			Title: data.Title,
			Description: data.Description,
			Url: data.Url,
			City: data.City,
			State: data.State,
			PlaceImage: data.PlaceImage,
			PlaceAttribute1: data.PlaceAttribute1,
			PlaceAttribute2: data.PlaceAttribute2,
			PlaceAttribute3: data.PlaceAttribute3,
			Latitude: data.Latitude,
			Longitude: data.Longitude,
			IsCulinaryGem: (data.IsCulinaryGem != null) ? data.CulinaryGem : false,
			IsJudgeFavorite: (data.IsCulinaryGem != null) ? data.CulinaryGem : false,
			Articles: data.Articles,
			CulinaryEpisode: data.CulinaryEpisode
		};

		var html = compiledTemplate(jsonContent);
		$('#reportDetails').html(html);

		showReportSubpane('report-detail');

		CulinaryBingMap.Map.zoomToPin(data);
	}

	return {
		addReportDetails: addReportDetails,
		clearDetailsShowAll: clearDetailsShowAll,
		emptyReportDetails: emptyReportDetails,
		hideReports: hideReports,
		getAllReportsByRegion: getAllReportsByRegion,
		getReportDetails: getReportDetails,
		showReports: showReports
	}
}());